import { CommandBase } from "./commandManager";
import { CommandType } from "./CommandType";
import { IPrimaryKey } from "./IPrimaryKey";

export abstract class BasicCommand<T> extends CommandBase {
    commandType: CommandType;
    groupKey: string;
    abstract primaryKey: IPrimaryKey<T>;
    constructor(typeName: string, groupKey: string, commandType: CommandType) {
        super(typeName);
        this.commandType = commandType;
        this.groupKey = groupKey;
    }

    markAsInsert() {
        this.commandType = CommandType.Insert;
    }
}
